import store from "../store";
import CandidateFunctions from '@/classes/CandidateFunctions';

export default async ( { next, router } ) => {
    
    if ( !CandidateFunctions.getCandidateToken() ) {
        
        if ( store.getters['candidate/getCandidatePin'] )
            CandidateFunctions.candidateLogout( store.getters['candidate/getCandidatePin'] );
        
        return router.push( { name: 'candidate.login' } ).catch(()=>{});
    }
    
    if ( store.getters['candidate/hasActiveTesting'] )
        return router.push( { name: 'candidate.test' } ).catch(()=>{});
    
    
    await CandidateFunctions.loadCandidate( true ).then( () => {
        
        if ( store.getters['candidate/hasActiveTesting'] ) {
            return router.push( { name: 'candidate.test' } ).catch(()=>{});
        }
        
        return next();
    } );
    
}
